import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../../components/Button/FormSubmitButton';
import ContactsCard from '../../../../components/Cards/ContactsCard';
import CustomSelectFieldWithCustomItemCard from '../../../../components/FormCom/CustomSelectFieldWithCustomItemCard';
import { FormComponent } from '../../../../components/FormCom/FormComponent';
import { Modal } from '../../../../components/Modal/Modal';
import SaveContactModal from '../../../../components/Modal/ModalActions/SaveContactModal/SaveContactModal';
import useSetSettings from '../../../../hooks/dashboard/settings/useSetSettings';
import {
  ContactsInitialValues,
  ContactsSchema,
} from '../../../../models/dashboard/settings/contacts';
import { useAppSelector } from '../../../../redux/store';

const contactCellData: { label: string; value: string; description: string }[] =
  [
    {
      label: 'Default',
      value: 'default',
      description: 'Your contacts will not be saved automatically.',
    },
    {
      label: 'Auto-save',
      value: 'auto-save',
      description: 'Your contacts will be automatically saved.',
    },
  ];

const Contacts = () => {
  const [showModal, setShowModal] = React.useState(false);
  const [modalMsg, setModalMsg] = React.useState('');
  const [formValue, setFormValue] = React.useState<any>(null);
  const { setSetting, loading } = useSetSettings();
  const { settingsData } = useAppSelector((state) => state.settingsData);

  const onSubmit = (values: any) => {
    setModalMsg(
      `${values.storageMode === 'auto-save' ? 'Your contacts will be automatically saved.' : 'Are you sure you want to switch to Default? Your contacts will no longer be saved automatically.'}`,
    );
    setShowModal(true);
    setFormValue(values);
  };

  ContactsInitialValues.storageMode = settingsData?.autosave
    ? 'auto-save'
    : 'default';

  return (
    <>
      <Box>
        <BoxTextArea>
          <BoxBoldText>Contacts</BoxBoldText>
          <BoxText>Set permissions for your address book contacts.</BoxText>
        </BoxTextArea>

        <FormComponent
          initialValues={ContactsInitialValues}
          schema={ContactsSchema}
          onSubmit={onSubmit}
        >
          <Row>
            <CustomSelectFieldWithCustomItemCard
              name='storageMode'
              id='storageMode'
              renderContent={contactCellData}
              renderComponent={(data) => <ContactsCard data={data} />}
              showErrorLabel={false}
            />
          </Row>

          <FormSubmitButton className='fit'>Save Changes</FormSubmitButton>
        </FormComponent>
      </Box>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <SaveContactModal
          msg={modalMsg}
          loading={loading}
          onConfirmFn={(callbackFn) =>
            setSetting(
              formValue?.storageMode === 'auto-save'
                ? { autosave: true }
                : { autosave: false },
              callbackFn,
            )
          }
        />
      </Modal>
    </>
  );
};

export default Contacts;

const Box = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: #fff;
`;

const BoxTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const BoxBoldText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const BoxText = styled.div`
  gap: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  font-weight: 500;
`;

const Row = styled.div`
  max-width: 400px;
`;
